import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'safe',
    standalone: false
})
export class SafePipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {}
  transform(url) {
    const Url = this.domSanitizer.sanitize(SecurityContext.URL, url.toString());
    return this.domSanitizer.bypassSecurityTrustResourceUrl(Url);
  }
}
